// extracted by mini-css-extract-plugin
export default {"container":"Y0-z","heading":"Z0-z","links":"_0-z","copy":"a1-z","subCopy":"b1-z","linksLeft":"c1-z","linksCenter":"d1-z","linksRight":"e1-z","link":"f1-z","onlyLink":"g1-z"};